import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, retry } from 'rxjs';
import { Constants } from '../constant';
import { Common } from '../../shared/common';
import { RoomAllocation, HostelCheckIn, HostelCheckOut } from '../models/hostel';

@Injectable()
export class HostelAllocationService {

  constructor(private http: HttpClient) { }

  private api = Constants.getApiEndpoint();

  // ─── Allocations ──────────────────────────────────────────────────────────

  allocate(allocation: RoomAllocation): Observable<any> {
    return this.http.post<any>(`${this.api}/hostel/allocations`, allocation, Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  cancelAllocation(id: string, reason: string): Observable<any> {
    return this.http.put<any>(`${this.api}/hostel/allocations/${id}/cancel`,
      { reason }, Common.httpOptions).pipe(retry(1), catchError(Common.handleError));
  }

  getActiveAllocations(stayIn: string = 'MAIN', hostelId: string = '', status: string = '', page = 0, size = 20, search: string = ''): Observable<any> {
    let url = `${this.api}/hostel/allocations?page=${page}&size=${size}`;
    if (hostelId) url += `&hostelId=${hostelId}`;
    if (status) url += `&status=${status}`;
    if (search && search.trim()) url += `&search=${encodeURIComponent(search.trim())}`;
    return this.http.get<any>(url, Common.campusHeader(stayIn)).pipe(retry(1), catchError(Common.handleError));
  }

  getAllocationById(id: string): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/allocations/${id}`)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getActiveAllocationByStudent(studentId: string, nonResident: boolean = false): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/allocations/student/${studentId}`,
      {
        params: {
          nonResident: nonResident.toString()
        }
      }
    )
      .pipe(retry(1), catchError(Common.handleError));
  }

  // ─── Check In ─────────────────────────────────────────────────────────────

  checkIn(request: HostelCheckIn): Observable<any> {
    return this.http.post<any>(`${this.api}/hostel/check-in`, request, Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getActiveCheckIn(studentId: string, nonResident: boolean = false): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/check-in/student/${studentId}`,
      {
        params: {
          nonResident: nonResident.toString()
        }
      }
    )
      .pipe(retry(1), catchError(Common.handleError));
  }

  hasActiveCheckIn(studentId: string, nonResident: boolean = false): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/check-in/student/${studentId}/status`,
      {
        params: {
          nonResident: nonResident.toString()
        }
      }
    )
      .pipe(retry(1), catchError(Common.handleError));
  }

  // ─── Check Out ────────────────────────────────────────────────────────────

  checkOut(request: HostelCheckOut, nonResident: boolean = false): Observable<any> {
    return this.http.post<any>(`${this.api}/hostel/check-out`, request,
      {
        params: {
          nonResident: nonResident.toString()
        }
      })
      .pipe(retry(1), catchError(Common.handleError));
  }
}
